import React, { Component } from "react";
import "./TextMessage.css";
const $ = window.$;
class TextMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnswer: "",
      count: 1
    };
  }

  render() {
    let marginTop = this.props.previousBySameSender === "true" ? 4 : 20;
    let obj = this.props.messageObj;
    let excludedSkills = this.props.excludedSkills;
    console.log(excludedSkills);
    let spanForBot = (
      <span
        className="message"
        data-toggle={this.props.messageBySender === "true" ? "tooltip" : ""}
        data-placement={this.props.messageBySender === "true" ? "left" : "right"}
        title={new Date(obj.timestamp).toLocaleString()}
        dangerouslySetInnerHTML={{
          __html: excludedSkills
            ? `Boolean : ${obj.label}
            <br />
            <br />
            <br />
            ${
              excludedSkills.length > 1
                ? `We believe <strong>${excludedSkills}</strong> are not really mandatory for this role .<br/>
            <br/>Still do you want to make it mandatory?`
                : `We believe <strong>${excludedSkills}</strong> is not really mandatory for this role .<br/>
                <br/>Still do you want to make it mandatory?`
            }
            <br />`
            : obj.label
        }}
      ></span>
    );
    let spanForUser = (
      <span
        className="message"
        data-toggle={this.props.messageBySender === "true" ? "tooltip" : ""}
        data-placement={this.props.messageBySender === "true" ? "left" : "right"}
        title={new Date(obj.timestamp).toLocaleString()}
      >
        {this.props.excludedSkills}
      </span>
    );
    return (
      <div
        className={
          "direct-chat-msg msg_left row " +
          (this.props.messageBySender === "true" ? "msg_right" : "")
        }
        style={{ marginTop: marginTop }}
      >
        <div
          className={
            "direct-chat-info clearfix row " +
            (this.props.messageBySender === "true" ||
            this.props.previousBySameSender === "true"
              ? "none"
              : "")
          }
        >
          <span className="direct-chat-name pull-left">Fellow Bot</span>{" "}
        </div>
        <div className="row">
          {this.props.messageBySender == "true" ? null : (
            <img src={this.props.botimage} alt="" className="direct-chat-img" />
          )}
          <div className="p">
            <span className="message_box">
              {/* {console.log(this.props.submitSingleChoiceAndwer, "xxxxxxxxxxx")} */}
              {this.props.messageBySender === "true" ? spanForUser : spanForBot}
              {this.props.excludedSkills ? (
                <div>
                  {this.state.selectedAnswer ? null : (
                    <div className="option-wrap">
                      {obj.options.map((opt, index) => {
                        return (
                          <div key={index}>
                            <div
                              className={
                                "comment-option bubble-animate " +
                                (this.state.selectedAnswer == opt
                                  ? "select"
                                  : "no-select")
                              }
                              onClick={() => this.selectMessage(opt)}
                              dangerouslySetInnerHTML={{ __html: opt }}
                            ></div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ) : (

                // this.state.count == 1 ?
                // this.newfunc() : null
                <div>
                  {this.state.selectedAnswer ? null : (
                    <div className="option-wrap">
                      {["Continue"].map((opt, index) => {

                        return (
                          <div key={index}>
                            <div
                              className={
                                "comment-option bubble-animate " +
                                (this.state.selectedAnswer == opt
                                  ? "select"
                                  : "no-select")
                              }
                              onClick={() => this.selectMessage(opt)}
                              dangerouslySetInnerHTML={{ __html: opt }}
                            ></div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }
  newfunc = () => {
    if(this.state.count === 1)
       this.selectMessage("nothing");
    this.setState({ count: 2 });
  };
  selectMessage = opt => {
    this.setState({ selectedAnswer: opt });
    if (this.props.booleanathonInitated) {
      this.props.submitBooleanResponse({
        label: opt,
        question: this.props.messageObj
      });
    } else this.props.submitSingleChoiceAnswer(this.props.messageObj, opt);
  };
  componentDidMount() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
}

export default TextMessage;
